import { render, staticRenderFns } from "./warehousereports.vue?vue&type=template&id=67369be2&"
import script from "./warehousereports.vue?vue&type=script&lang=js&"
export * from "./warehousereports.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports